import CtaBand from "./home/CtaBand";
import ContactSection from "./home/ContactSection";
import DentistSection from "./home/DentistSection";
import FeatureStrip from "./home/FeatureStrip";
import HeroSection from "./home/HeroSection";
import ResultsSection from "./home/ResultsSection";
import ServicesPreview from "./home/ServicesPreview";
import TestimonialsPreview from "./home/TestimonialsPreview";
import TrustSection from "./home/TrustSection";
import MobileHome from "./home/MobileHome";

export default function Hero() {
  return (
    <main className="max-w-[100vw] overflow-hidden bg-white font-sans text-[#071746]" data-testid="hero-section">
      <div className="lg:hidden"><MobileHome /></div>
      <div className="hidden lg:block">
        <HeroSection />
        <FeatureStrip />
        <TrustSection />
        <ServicesPreview />
        <DentistSection />
        <ResultsSection />
        <TestimonialsPreview />
        <ContactSection />
        <CtaBand />
      </div>
    </main>
  );
}
